import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import ErrorPage from "./error/error-page";
import reportWebVitals from "./reportWebVitals";
import Login from "./_Containers/Login";
import PrivateRoute from "./routes/privateRoute";
import Dashboard from "./_Components/Dashboard";
import Vendors from "./_Containers/Vendors";
import CreateEditVendorStepper from "./_Components/VendorLayout/CreateEditVendor";
import { getVendors } from "./Utils/vendor-customer-service";
import VendorDetail from "./_Components/VendorLayout/VendorDetail";
import VendorWishlist from "./_Components/VendorLayout/VendorWishlist";
import Estimate from "./_Components/EstimateLayout/Estimate";
import EstimateDetail from "./_Components/EstimateLayout/EstimateDetail";
import Banners from "./_Components/Banners";
import SecondaryBanners from "./_Components/SecondaryBanners";
import OutOfStockProducts from "./_Components/StoreLayout/OutOfStockProducts";
import DraftProducts from "./_Components/StoreLayout/DraftProducts";
import InquiredProducts from "./_Components/StoreLayout/InquiredProducts";
import Categories from "./_Components/StoreLayout/Categories";
import UnpublishedCategories from "./_Components/StoreLayout/UnpublishedCategories";

const router = createBrowserRouter([
  // {
  //   path: "/",
  //   element: <PrivateRoute path="/" component={Dashboard} />,
  //   exact: true,
  //   errorElement: <PrivateRoute path="/" component={ErrorPage} />,
  // },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "/",
    element: <PrivateRoute component={Estimate} />,
    loader: getVendors,
  },
  {
    path: "estimate/:vendorID/:estimateId",
    element: <PrivateRoute component={EstimateDetail} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "vendors",
    loader: getVendors,
    element: <PrivateRoute component={Vendors} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "vendors/create",
    element: <PrivateRoute component={CreateEditVendorStepper} />,
  },
  {
    path: "vendor/:vendorID",
    element: <PrivateRoute component={VendorDetail} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "vendor/:vendorID/wishlist",
    element: <PrivateRoute component={VendorWishlist} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "banners",
    element: <PrivateRoute component={Banners} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "banners/secondary",
    element: <PrivateRoute component={SecondaryBanners} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "store/inquired",
    element: <PrivateRoute component={InquiredProducts} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "store/out-of-stock",
    element: <PrivateRoute component={OutOfStockProducts} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "store/draft",
    element: <PrivateRoute component={DraftProducts} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "store/categories",
    element: <PrivateRoute component={Categories} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
  {
    path: "store/unpublished-categories",
    element: <PrivateRoute component={UnpublishedCategories} />,
    errorElement: <PrivateRoute component={ErrorPage} />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    {/* <App /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
